import { render } from "./FacetPanel.vue?vue&type=template&id=066a0d0e&scoped=true&ts=true"
import script from "./FacetPanel.vue?vue&type=script&lang=ts"
export * from "./FacetPanel.vue?vue&type=script&lang=ts"

import "./FacetPanel.vue?vue&type=style&index=0&id=066a0d0e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066a0d0e"]])

export default __exports__